import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isToolbarActive", "responsiveSize", "label"];
import { forwardRef } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { TrellisBaseToolbar } from './BaseToolbar';
import { SMALL_RESPONSIVE_SIZE } from './constants';
import { DownCaratIcon } from 'foundations-assets/icons/components/DownCaratIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CustomDropdownButton = _ref => {
  let {
      isToolbarActive,
      responsiveSize,
      label
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isSmall = responsiveSize === SMALL_RESPONSIVE_SIZE;
  return /*#__PURE__*/_jsxs(Button, Object.assign({}, rest, {
    paddingBlock: "200",
    paddingInline: isSmall ? '200' : '300',
    disabled: !isToolbarActive,
    use: "primary",
    size: "small",
    children: [!isSmall && label, /*#__PURE__*/_jsx(DownCaratIcon, {
      alignWithText: true
    })]
  }));
};
const SimpleActionsToolbar = (props, ref) => {
  return /*#__PURE__*/_jsx(TrellisBaseToolbar, Object.assign({}, props, {
    forwardedRef: ref,
    CustomDropdownButton: CustomDropdownButton,
    arrowSize: "none"
  }));
};
export default /*#__PURE__*/forwardRef(SimpleActionsToolbar);